

















	import { Component, Prop, Vue } from 'vue-property-decorator'
	import Vasilkov from '@/components/Sliders/Vasilkov.vue'
    import CuttingSlider from '@/components/Sliders/CuttingSlider.vue'
    import Slider from '@/components/Sliders/BeforeAfterSlider.vue'



    @Component({
		components: {
			Vasilkov,
            CuttingSlider,
            Slider
		}
	})
    export default class SlidersPage extends Vue {
        data() {
            return {
                PageTitle: "SlidersPage"
            }
        }
        mounted() {
        }
    }
